import BaseControlTypeConst from "./BaseControlTypeConst"

export default class HtmlTypeConst extends BaseControlTypeConst {
    
  static TEXT = 'text'

}
